import React from 'react';

const STEPS = [
    { n: '1', t: 'Book a 20-minute call', d: 'Mark will confirm your fit for the AppStore and discuss your target audience on the platform.' },
    { n: '2', t: 'We build your listing', d: 'We create your AppStore card and partner page. You review and approve. No tech work required on your end.' },
    { n: '3', t: 'Go live and receive introductions', d: 'Your listing goes live in the AppStore. Contextual recommendations start surfacing your solution to relevant users immediately.' },
];

const PartnerStepsSection = () => (
    <section className="lp-partner-steps">
        <h2 className="lp-partner-steps-head" data-lp-reveal>How can I be a partner?</h2>
        <div className="lp-partner-steps-grid">
            <div className="lp-partner-steps-line" aria-hidden="true" />
            {STEPS.map((s, i) => (
                <div className="lp-partner-step" key={i} data-lp-reveal data-lp-delay={i * 120}>
                    <div className="num">{s.n}</div>
                    <h3>{s.t}</h3>
                    <p>{s.d}</p>
                </div>
            ))}
        </div>
    </section>
);

export default PartnerStepsSection;
